import {gql} from "@apollo/client";

export const loginUserMutation = gql`
  mutation signIn($email: String!, $password: String!){
    signinUser(
      input: {credentials: {
        email: $email,
        password: $password
      }}) {
      token
      user {
        id
        email
        fName
        lName
        phone
        fullName
        avatar
        type
        unreadNotificationsCount
      }
    }
  }`

export const updateProfileQuery = gql`
  mutation updateUser($email: String!, $password: String!, $fName: String!, $lName: String!, $phone: String){
    updateUser(
      input: {
        email: $email,
        password: $password,
        fName: $fName,
        lName: $lName,
        phone: $phone
      }) {
      user {
        id
        email
        fName
        lName
        phone
        type
        fullName
        avatar
        unreadNotificationsCount
      }
    }
  }
`

export const getCurrentUser = gql`
  query currentUser {
    me {
      id
      email
      fName
      lName
      phone
      type
      fullName
      avatar
      unreadNotificationsCount
    }
  }
`

export const getPlan = gql`
  query getPlan {
    plan {
      id, name, features, price
      usersLimit, usersCount
      menusLimit, menusCount
    }
  }
`

export const REGISTER_MUTATION = gql`
  mutation register($planId: ID!, $email: String!, $password: String!, $fName: String!, $lName: String!, $phone: String){
    registerUser(
      input: {
        email: $email,
        password: $password,
        fName: $fName,
        lName: $lName,
        phone: $phone
        planId: $planId
      }) {
      token
      user {
        id
        email
        fName
        lName
        phone
        fullName
        avatar
      }
    }
  }
`